module.exports = __webpack_public_path__ + "img/maydolis-cabrera-office-manager.cef5d417.jpg";